import { render, staticRenderFns } from "./UmsUserInfoView.vue?vue&type=template&id=46f93acd&"
import script from "./UmsUserInfoView.vue?vue&type=script&lang=js&"
export * from "./UmsUserInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports